export class StudyValidationErrorResponse {
  name: any;
  description: any;
  'primaryEntity.entityId': any;
}
